import { createSlice } from '@reduxjs/toolkit';
import { fetchDashboard, fetchDashboardNotices } from './actions';
import { Dashboard } from '../Model/Dashboard';
import { Notice } from '../../Notice/Model/Notice';

interface State {
  stats?: Dashboard;
  recent: Notice[];
  loading: boolean;
  error?: string;
}
const initialState: State = { recent: [], loading: false };

const slice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: b => {
    b.addCase(fetchDashboard.pending, s => { s.loading = true; })
     .addCase(fetchDashboard.fulfilled, (s, a) => { s.stats = a.payload; s.loading = false; })
     .addCase(fetchDashboard.rejected, (s, a) => { s.loading = false; s.error = a.error.message; })
     .addCase(fetchDashboardNotices.fulfilled, (s, a) => { s.recent = a.payload; });
  },
});
export default slice.reducer;
